
import XCircleIcon from "@/assets/svg/heroicons/x-circle.svg?inline=1";
import Vue from "vue";
import { mixin as clickaway } from "vue-clickaway";
import LocationIcon from "~/assets/svg/heroicons/location.svg?inline=1";
import StoreInfoWindow from "~/components/StoreInfoWindow";
import Search2LineIcon from "~/assets/svg/heroicons/search-2-line.svg?inline=1";
import EqualizerLineIcon from "~/assets/svg/heroicons/equalizer-line.svg?inline=1";
import closemobile from "~/assets/svg/closemobile.svg?inline=1";
import { ContentLoader } from "vue-content-loader";

export default {
  components: {
    XCircleIcon,
    LocationIcon,
    Search2LineIcon,
    EqualizerLineIcon,
    ContentLoader,
    closemobile,
  },
  mixins: [clickaway],
  data() {
    return {
      map: null,
      autocomplete: null,
      markerClusterer: null,
      isMobileDrawer: false,
      isMobile: false,
      place: {
        lat: null,
        lng: null,
      },
      searchQuery: "",
      distance: 50,
      distanceUnit: "km",
      services: [],
      stores: [],
      selectedStore: null,
      markers: [],
      infoWindows: [],
      markerIcon: null,
      isDropdownOpen: false,
      activetab: "km",
      servicesList: [],
      isEmpty: false,
      isLoading: false,
      isFetching: false,
      tabs: [
        this.$t("common.all"),
        this.$t("common.store"),
        this.$t("common.service"),
      ],
    };
  },
  mounted() {
    if (!process.browser) {
      return;
    }

    this.$loadBaiduMap().then(() => {
      const BMAP_ANCHOR_BOTTOM_RIGHT = window.BMAP_ANCHOR_BOTTOM_RIGHT;
      this.map = new window.BMap.Map("map", {
        minZoom: 6,
        maxZoom: 22,
      });

      this.markerIcon = new window.BMap.Icon(
        require("../../assets/images/map-marker.png"),
        new window.BMap.Size(20, 20),
        {
          imageSize: new window.BMap.Size(20, 20),
          imageOffset: new window.BMap.Size(0, 0),
          anchor: new window.BMap.Size(20 / 2, 0),
        }
      );

      // Add GUI controls and buttons
      this.addControls();
      this.map.centerAndZoom(new window.BMap.Point(103.56, 36.71), 5);
      this.map.enableScrollWheelZoom();
      // Bind autocomplete
      this.autocomplete = new window.BMap.Autocomplete({
        input: this.$refs.autocomplete,
        location: this.map,
      });

      this.autocomplete.addEventListener("onconfirm", (e) => {
        const place = e.item.value;
        const fullAddress = `${place.province}${place.city}${place.district}${place.street}${place.business}`;
        this.map.clearOverlays();

        const local = new window.BMap.LocalSearch(this.map, {
          onSearchComplete: () => {
            const results = local.getResults();
            if (!results || !results.getPoi(0).point) {
              alert("Autocomplete's returned place contains no geometry");
              return;
            }

            const location = results.getPoi(0).point;
            this.$nextTick(() => {
              this.place = {
                lat: location.lat,
                lng: location.lng,
              };
              this.searchQuery = fullAddress;
              this.searchPlace();
            });
          },
        });

        local.search(fullAddress);
      });

      window.onresize = this.reportWindowSize;

      this.setCompanyCenter();
      const normalMapBtn = document.getElementById("normalMapBtn");
      const satelliteMapBtn = document.getElementById("satelliteMapBtn");

      // Add event listeners to switch map types
      normalMapBtn.addEventListener("click", () => {
        this.map.setMapType(window.BMAP_NORMAL_MAP);
        updateActiveButton(normalMapBtn, satelliteMapBtn);
      });

      satelliteMapBtn.addEventListener("click", () => {
        this.map.setMapType(window.BMAP_SATELLITE_MAP);
        updateActiveButton(satelliteMapBtn, normalMapBtn);
      });
      function updateActiveButton(activeBtn, inactiveBtn) {
        activeBtn.classList.add("hidden");
        inactiveBtn.classList.remove("hidden");
      }

      // Initialize the map with normal map type as active
      updateActiveButton(normalMapBtn, satelliteMapBtn);

      // Load MarkerClusterer library
    });
  },
  methods: {
    addControls() {
      // Map Type Control (similar to Google Maps mapTypeControlOptions)
      const mapTypeControl = new window.BMap.MapTypeControl({
        mapTypes: [window.BMAP_NORMAL_MAP, window.BMAP_SATELLITE_MAP],
        anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT,
      });
      this.map.addControl(mapTypeControl);
      function CustomFullscreenControl() {
        this.defaultAnchor = BMAP_ANCHOR_BOTTOM_RIGHT;
        this.defaultOffset = new BMap.Size(10, 50); // Adjust position to avoid overlap with map type control
      }
      // Inherit from BMap.Control
      CustomFullscreenControl.prototype = new BMap.Control();

      // Implement the initialize
      CustomFullscreenControl.prototype.initialize = function (map) {
        var div = document.createElement("div");
        div.className = "custom-fullscreen";

        // Ensure bottom and right properties are set explicitly
        div.style.bottom = "10px";
        div.style.right = "10px";

        // Append the control to the map container
        map.getContainer().appendChild(div);

        // Toggle fullscreen when clicking on the control
        div.addEventListener("click", function () {
          toggleFullscreen(map.getContainer());
        });

        return div;
      };
      // Add the custom control to the map
      var myFullscreenCtrl = new CustomFullscreenControl();
      this.map.addControl(myFullscreenCtrl);
      // Fullscreen toggle function
      function toggleFullscreen(element) {
        if (!document.fullscreenElement) {
          element.requestFullscreen().catch((err) => {
            alert(
              `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`
            );
          });
        } else {
          document.exitFullscreen();
        }
      }

      // Listen for fullscreen change events to adjust the map
      document.addEventListener("fullscreenchange", () => {
        if (document.fullscreenElement) {
          document.getElementById("map").classList.add("fullscreen-map");
        } else {
          document.getElementById("map").classList.remove("fullscreen-map");
        }
      });

      // Function to update active button style and visibility

      const navigationControl = new window.BMap.NavigationControl({
        type: window.BMAP_NAVIGATION_CONTROL_LARGE,
        anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT,
        enableGeolocation: true,
      });
      this.map.addControl(navigationControl);
      function CustomStreetViewControl() {
        this.defaultAnchor = BMAP_ANCHOR_BOTTOM_RIGHT;
        this.defaultOffset = new BMap.Size(10, 50); // Adjust the offset to place it correctly
      }
      // Add street view control
      CustomStreetViewControl.prototype = new BMap.Control();

      // Implement the initialize method
      const map = this.map;
      CustomStreetViewControl.prototype.initialize = function (map) {
        var div = document.createElement("div");
        div.className = "custom-streetview";
        div.onclick = function (e) {
          var panorama = new BMap.Panorama(map.getContainer());
          map.addOverlay(panorama);
          panorama.setPosition(map.getCenter());
          panorama.setPov({ heading: -40, pitch: 6 });
        };
        map.getContainer().appendChild(div);
        return div;
      };

      // Add the custom control to the map
      var myStreetViewCtrl = new CustomStreetViewControl();
      this.map.addControl(myStreetViewCtrl);
      // Scale Control
      const scaleControl = new window.BMap.ScaleControl({
        anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT,
      });
      this.map.addControl(scaleControl);

      // Rotate Control (similar to Google Maps rotateControl)

      // Fullscreen Control (similar to Google Maps fullscreenControlOptions)
      const fullscreenControl = new window.BMap.Control({
        anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT,
        type: window.BMAP_NAVIGATION_CONTROL_ZOOM,
      });
      this.map.addControl(fullscreenControl);
    },
    onSearch(e) {
      this.searchQuery = e.target.value;

      if (!this.searchQuery) {
        this.isEmpty = true;
        this.resetState();
      } else {
        this.isEmpty = false;
      }
    },
    onToggleDrawer() {
      this.isMobileDrawer = !this.isMobileDrawer;
    },
    onOpenDrawer() {
      if (this.isMobile) {
        this.isMobileDrawer = true;
      }
    },
    onSwitchDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isMobile) {
        this.isMobileDrawer = true;
      }
    },
    reportWindowSize(e) {
      if (window.innerWidth >= 768) {
        this.isMobileDrawer = false;
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
      setTimeout(() => {
        this.updateIcons();
      }, 200);
    },
    storeInfoCurrentTab(tab) {
      if (tab === "Store") {
        this.distributorCategories = ["point_of_sale"];
      } else if (tab === "Service") {
        this.distributorCategories = ["service_center"];
      } else if (tab === "All") {
        this.distributorCategories = [];
      }
      this.onOpenDrawer();

      this.searchPlace({ use_distance: this.searchQuery.length > 0 });
    },
    activeTabMethod(currentTab) {
      this.activetab = currentTab;
      this.distanceUnit = this.activetab;
      if (!this.searchQuery) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }
      this.searchPlace({ use_distance: this.searchQuery.length > 0 });
    },
    searchPlaceWithFill(data) {
      if (!this.searchQuery) {
        this.isEmpty = true;
        return;
      }
      this.isEmpty = false;
      this.searchPlace(data);
    },
    away() {
      this.isEmpty = false;
      this.isDropdownOpen = false;
    },
    toggleService(serviceKey) {
      const existsIndex = this.services.indexOf(serviceKey);
      if (existsIndex === -1) {
        this.services.push(serviceKey);
      } else {
        this.services.splice(existsIndex, 1);
      }

      this.searchPlace({ use_distance: this.searchQuery.length > 0 });
    },

    setCompanyCenter() {
      this.place = {
        lat: parseFloat(this.$store.state.currentSite.country.country_lat),
        lng: parseFloat(this.$store.state.currentSite.country.country_long),
      };

      this.searchPlace({ use_distance: false });
    },

    isGeoEnabled() {
      if (!process.browser) {
        return false;
      }

      return "geolocation" in navigator;
    },

    getCurrentPosition() {
      if (!this.isGeoEnabled()) {
        return;
      }

      const geolocation = new window.BMap.Geolocation();

      geolocation.getCurrentPosition(
        (position) => {
          if (Object.keys(position.address).length !== 0) {
            /* eslint-disable camelcase */
            const { street, street_number, district, province, city } =
              position.address;

            this.searchQuery =
              (street.length > 0 ? street : "") +
              (street_number.length > 0 ? street_number : "") +
              (district.length > 0 ? `, ${district}` : "") +
              (province.length > 0 ? `, ${province}` : "") +
              (city.length > 0 ? `, ${city}` : "");

            this.place = {
              lat: position.latitude,
              lng: position.longitude,
            };

            this.searchPlace({ use_distance: this.searchQuery.length > 0 });
          }
        },
        (error) => {
          if (error.code) {
            this.setCompanyCenter();
          }
        },
        {
          timeout: 70000,
          enableHighAccuracy: true,
          maximumAge: 75000,
        }
      );
    },

    closeInfoWindows() {
      this.infoWindows.forEach((info, index) => {
        this.markers[index].closeInfoWindow();
      });
    },

    goToMarker(index) {
      this.isMobileDrawer = false;
      if (index === this.selectedStore) {
        return;
      }
      this.isMobileDrawer = false;

      this.closeInfoWindows();

      const point = new window.BMap.Point(
        this.stores[index].position.lng,
        this.stores[index].position.lat
      );

      this.markers[index].openInfoWindow(this.infoWindows[index]);
      this.map.centerAndZoom(point, 15);
      this.selectedStore = index;
    },

    resetData() {
      // clear infowindow
      this.closeInfoWindows();
      this.infoWindows = [];

      if (this.markerClusterer) {
        this.markerClusterer.clearMarkers();
      }

      // clear markers
      this.markers.forEach((marker, index) => this.map.removeOverlay(marker));
      this.markers = [];

      // reset stores
      this.stores = [];
      this.selectedStore = null;
    },

    resetState() {
      this.searchQuery = "";
      this.setCompanyCenter();
      this.searchPlace();
    },

    setMapCenterByMarkersPoint() {
      const points = [];
      for (let i = 0; i < this.markers.length; i++) {
        points.push(this.markers[i].point);
      }

      this.map.setViewport(points);
    },

    async searchPlace(params) {
      this.resetData();
      try {
        this.isLoading = false;

        const res = await this.$axios.$get("/api/front/stores/services");
        this.servicesList = res;
        console.log(this.servicesList);

        const { data } = await this.$axios.$get("/api/front/stores/v2", {
          params: Object.assign(
            {
              distance: this.distance,
              distance_unit: this.distanceUnit,
              lat: this.place.lat,
              lng: this.place.lng,
              services: this.services,
              use_distance: true,
              distributor_categories: this.distributorCategories,
            },
            params
          ),
        });
        this.stores = data;

        this.stores.forEach((store) =>
          setTimeout(() => this.addMarker(store), 5)
        );

        setTimeout(() => {
          console.log(this.markers.length);
          if (this.markers.length > 0) {
            const styles = [
              {
                url: require("../../assets/images/count-marker.svg"),
                size: new window.BMap.Size(55, 55),
                textColor: "#fff",
                textSize: 13,
              },
            ];

            this.markerClusterer = new window.BMapLib.MarkerClusterer(
              this.map,
              {
                markers: this.markers,
                styles: styles,
              }
            );
          }
        }, 1000);
      } catch (error) {
        console.error(error);
      }
    },

    addMarker(data, index) {
      const point = new window.BMap.Point(data.position.lng, data.position.lat);

      if (isNaN(point.lat) || isNaN(point.lng)) {
        console.warn("☢️ wrong position");
        console.table(data);
        return;
      }

      const marker = new window.BMap.Marker(point, {
        icon: this.markerIcon,
      });

      this.map.addOverlay(marker);

      this.markers.push(marker);
      // Custom cluster styles

      const StoreInfoWindowCmp = Vue.extend(StoreInfoWindow);
      const StoreInfoWindowInstance = new StoreInfoWindowCmp({
        parent: this,
        propsData: {
          baidu: true,
          distance: data.distance,
          info: data.info,
          position: data.position,
          showDetail: true,
        },
      }).$mount();

      const infoWindow = new window.BMap.InfoWindow(
        StoreInfoWindowInstance.$el,
        {
          minWidth: 200,
          minHeight: 100,
          borderRadius: 50,
        }
      );

      this.infoWindows.push(infoWindow);

      marker.addEventListener("click", function () {
        marker.openInfoWindow(infoWindow);
        this.map.centerAndZoom(point, 15);
      });
    },
  },
  head() {
    return {
      title: this.$t("common.stores_and_inventories"),
    };
  },
};
